<template>
  <div :class='$style.container'>
    <loading-overlay v-show='busy' :transparent='true' />
    <img :class="$style.jiminnyLogo" src="../../assets/img/jiminny-logo-white-long-2x.png" alt="Jiminny Logo" />
    <p>Select your work account</p>

    <div :class="$style.providers">
      <google-sign-in-button
        :class="$style.gSigninButton"
        @success="authJiminny"
        @error="onSignInError">
        <span :class="$style.icon"><FontAwesomeIcon :icon="faGoogle" /></span>Sign in with Google</google-sign-in-button>

      <office-sign-in-button
        :class="$style.officeSigninButton"
        @success="authJiminny"
        @error="onSignInError">
        <span :class="$style.icon"><FontAwesomeIcon :icon="faMicrosoft" /></span>Sign in with Office 365</office-sign-in-button>
    </div>

    <div :class="$style.region">
      <a :href="otherRegion.url">Switch to {{otherRegion.name}}</a>
    </div>
  </div>
</template>

<script>
  import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
  import { faGoogle } from '@fortawesome/free-brands-svg-icons/faGoogle'
  import { faMicrosoft } from '@fortawesome/free-brands-svg-icons/faMicrosoft'
  import store from '@/lib/store'
  import { jiminnyHost } from '@/helpers/region'
  import EventBus from '@/lib/event-bus'
  import { Base64 } from 'js-base64'
  import URI from 'urijs'
  import GoogleSignInButton from './google-sign-in-button/google-sign-in-button'
  import OfficeSignInButton from './office-sign-in-button/office-sign-in-button'
  import * as Notifications from './notifications'
  import LoadingOverlay from '@/components/loading-overlay/loading-overlay'

  const uri = URI()
  const tld = uri.tld()

  const regions = [
    {
      name: 'World',
      url: `${uri.tld('com').origin()}/logout`
    },
    {
      name: 'EU',
      url: `${uri.tld('eu').origin()}/logout`
    }
  ]

  export default {
    components: {
      FontAwesomeIcon,
      GoogleSignInButton,
      OfficeSignInButton,
      LoadingOverlay
    },
    data () {
      return {
        busy: this.$route.hash.includes('id_token'),
        faGoogle,
        faMicrosoft
      }
    },
    computed: {
      region () {
        if (tld === 'com') {
          return regions.find(region => region.name === 'World')
        } else {
          return regions.find(region => region.name === 'EU')
        }
      },
      otherRegion () {
        if (tld === 'com') {
          return regions.find(region => region.name === 'EU')
        } else {
          return regions.find(region => region.name === 'World')
        }
      }
    },
    mounted () {
      store.set('region', this.region)
    },
    methods: {
      authJiminny ({ email, token }) {
        this.$http
          .get(`${jiminnyHost()}/api/v1/user/chrome-extension-authentication`, {
            headers: {
              'Authorization': 'Basic ' + Base64.encode(`${email}:${token}`)
            }
          })
          .then(response => {
            this.initStore(response.data, email)
            this.loadNextPage()
          })
          .catch(error => {
            console.log(error)
            const response = error.response
            this.busy = false
            if (response && response.status !== 401) {
              Notifications.errorNotification({ message: response.data.error.message }).show()
            }
          })
      },
      initStore (jiminnyAuthData, email) {
        EventBus.$emit('REPLACE_CONFIG', {
          ...store.data(),
          ...jiminnyAuthData.state,
          token: jiminnyAuthData.token,
          deviceId: jiminnyAuthData.deviceId,
          email
        })
      },
      loadNextPage () {
        if (store.get('phoneAction')) {
          EventBus.$emit('PROCESS_PHONE_ACTION')
        } else {
          this.$router.push('/')
        }
      },
      onSignInError (error) {
        this.busy = false
        console.error(error)
      }
    }
  }
</script>

<style module lang='less' src='./login.less'></style>



// WEBPACK FOOTER //
// login.vue?0b0f356d